import styled from 'styled-components';
import { Crate, Text } from '@perch-labs/shrike';

export const InfoBox = styled.div`
  background: ${props => props.theme.colors.background.secondary};
  border-radius: 8px;
  padding: 16px;
  width: 100%;
`;

export const TotalDueArcadia = styled(Text).attrs({
  color: 'secondary',
  margin: { bottom: '8px' },
})`
  font-weight: 700;
  font-size: 2.25rem;
`;

export const ToUtilityCrate = styled(Crate).attrs({
  width: {
    default: '100%',
    tabletPortraitUp: '50%',
  },
  margin: {
    default: '0',
    tabletPortraitUp: {
      top: '24px',
      bottom: '24px',
    },
  },
  padding: {
    default: {
      top: '24px',
      bottom: '24px',
    },
    tabletPortraitUp: {
      left: '24px',
      right: '24px',
    },
  },
})``;
